import styled from "styled-components";

export const QuotaUpgradeWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
  text-align: center;
`;

export const QuotaUpgradeCopy = styled.p`
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.5;
  color: #6b7280;
`;
